// OSM-10388: All success/error/info messages must be stored here with code details: <CATEGORY>-<SEVERITY>-<CODE>
// CATEGORY: PROFILEINFO,PROFILEREGO,EMAILITINERARY,MAINTENANCE
// SEVERITY: CRITICAL,WARNING,INFORMATION
//  - CRITICAL = Non recoverable errors e.g. mobile number has been used, itinerary data not found
//  - WARNING = Recoverable errors, can be retried, service down etc
//  - INFORMATION = not an error, successful processing
// CODE: xxxx
//  - 1st x = PROFILEREGO: 1, PROFILEINFO: 2, EMAILITINERARY: 3, MAINTENANCE: 4, CLEAN: 5
//  - 2nd x = INFORMATION: 1, WARNING: 2, CRITICAL: 3
//  - 3rd and 4th x = Sequential number
const messages = {
    'PROFILEREGO-WARNING-1201' : {
        msg: 'Sorry, we were unable to deregister your device. Please try again.'
    },
    // database error on deregistration
    'PROFILEREGO-WARNING-1202' : {
        msg: 'Sorry, we were unable to update your profile. Please try again.'
    },
    // database error on profile update
    'PROFILEREGO-INFORMATION-1103': {
        msg: 'Mobile number {mobileNumber} is no longer registered.'
    },
    // successful deregistration
    'PROFILEREGO-CRITICAL-1304': {
        msg: 'Nope! That did not work. Wrong PIN?'
    },
    // invalid PIN supplied
    'PROFILEREGO-CRITICAL-1305': {
        msg: 'Whoops? Your device is already unregistered.'
    },
    // duplicate deregistration request
    'PROFILEREGO-CRITICAL-1306': {
        msg: 'Nope! That did not work? Please apply for a new PIN.'
    },
    // PIN is no longer valid
    'PROFILEREGO-CRITICAL-1307': {
        msg: 'Hmmm?.. Your device registration is no longer valid! Please apply for a new PIN.'
    },
    // device registration has been deleted
    'PROFILEREGO-CRITICAL-1308': {
        msg: 'Uh Oh! We cannot find you? Please register again.'
    },
    // device registration not found
    'PROFILEREGO-WARNING-1209': {
        msg: 'Sorry, we were unable to retrieve your profile information! Please try again.'
    },
    // database error on fetch
    'PROFILEREGO-CRITICAL-1310': {
        msg: 'Oh snap! Your PIN could not be verified. Please contact your Site Travel Administrator.'
    },
    // device PIN not verified
    'PROFILEINFO-WARNING-2211': {
        msg: 'Whoops? We could not retrieve your bookings and newsboard. Please try again.'
    },
    // database error on fetch
    'PROFILEREGO-WARNING-1213': {
        msg: 'Sorry, we could not update your PIN? Please try again.'
    }, // database error on update
    'PROFILEREGO-WARNING-1214': {
        msg: 'Sorry, we could not reset your PIN? Please try again.'
    },
    // database error on update
    'PROFILEREGO-WARNING-1215': {
        msg: 'Sorry, this user has already been invited. Please try again with a different phone number.'
    },
    // invite alread exsts
    'PROFILEREGO-WARNING-1217': {
        msg: 'Sorry, we are unable to add this sub user currently. Please try again.'
    },
    // db error
    'PROFILEREGO-WARNING-1219': {
        msg: 'Sorry, we are unable to retrieve your sub accounts. Please try again.'
    },
    // db error
    'PROFILEREGO-WARNING-1220': {
        msg: 'Sorry, this sub account has been registered previously. Please contact the profile owner to re-invite when required.'
    },
    // db error
    'PROFILEREGO-WARNING-1221': {
        msg: 'Sorry, we were unable to remove this sub account currently. Please try again.'
    },
    // db error, failed to remove sub user
    'PROFILEREGO-CRITICAL-1315': {
        // tslint:disable-next-line:max-line-length
        msg: 'Ooops! It seems the number {mobileNumber} is already registered? Please contact your Site Travel Administrator to confirm your Kiosk membership. '
    },
    // invalid registration details
    'PROFILEREGO-WARNING-1216': {
        msg: 'Oh snap! Unable to send TXT? {errorDetails}'
    },
    // SMS error
    'PROFILEREGO-INFORMATION-1117': {
        msg: 'TXT successfully sent to {mobileNumber}'
    },
    // successfully sent SMS
    'PROFILEREGO-INFORMATION-1118': {
        msg: 'Successfully removed sub account'
    },
    // successfully sent SMS
    'PROFILEREGO-INFORMATION-1119': {
        msg: 'Successfully removed linked account'
    },
    // successfully unlink sub user from master user
    'PROFILEREGO-INFORMATION-1120': {
        msg: 'Successfully invited user to view your itinerary'
    },
    // Master user successfully invited a sub user
    'PROFILEREGO-WARNING-1218': {
        msg: 'Whoops! We could not verify your PIN? Please try again.'
    },
    // database error on fetch
    'PROFILEREGO-CRITICAL-1319': {
        msg: 'Ooops, it seems you are already verified?'
    },
    // duplicate registration request
    'PROFILEREGO-CRITICAL-1320': {
        msg: 'Houston, we have a problem! Please start your registration again...'
    },
    // default registration failed message
    // mostly used in profileInfoBL.js
    'PROFILEINFO-CRITICAL-2321': {
        msg: 'Doh! Config error? Please contact your Site Travel Administrator.'
    },
    // no site prefix supplied
    'PROFILEINFO-CRITICAL-2322': {
        msg: 'Doh! Config error? Please contact your Site Travel Administrator.'
    },
    // no matching API key found
    'PROFILEINFO-CRITICAL-2323': {
        msg: 'Doh! Config error? Please contact your Site Travel Administrator.'
    },
    // database error - could not fetch API key
    'PROFILEINFO-CRITICAL-2324': {
        msg: 'Doh! Config error? Please contact your Site Travel Administrator.'
    },
    // site prefix mismatch
    'PROFILEINFO-CRITICAL-2325': {
        msg: 'Doh! Config error? Please contact your Site Travel Administrator.'
    },
    // no API key supplied
    'PROFILEINFO-WARNING-2226': {
        msg: 'Whoops! Unable to update your info? Please try again.'
    },
    // database error on insert / update
    'PROFILEINFO-WARNING-2227': {
        msg: 'Uh Oh! Sync failed? Please try again.'
    },
    // database error on last sync info
    'PROFILEINFO-WARNING-2228': {
        msg: 'We could not let you go! Please try again.'
    },
    // database error on profile remove
    // mostly used in service.js
    'PROFILEREGO-INFORMATION-1129': {
        msg: 'PIN verified successfully.'
    },
    // successful registration
    'PROFILEINFO-CRITICAL-2330': {
        msg: 'Uh Oh! We seem to have a problem with your mobile number? Please contact your Site Travel Administrator.'
    },
    // found profile local data, but no mobile number is present
    'PROFILEINFO-CRITICAL-2331': {
        msg: 'Hmmm? Your profile seems to be missing! Please contact your Site Travel Administrator.'
    },
    // no local data for profile
    'PROFILEREGO-WARNING-1236': {
        msg: 'Ooops, the server seems to be down? Please try again.'
    },
    // no response from server
    // mostly used in controller.js
    'PROFILEINFO-INFORMATION-2132': {
        msg: 'Profile updated successfully'
    },
    // local data saved
    'PROFILEREGO-CRITICAL-1333': {
        msg: 'Hey! We cannot contact you on {mobileNumber}? All numbers must match the format +&lt;CountryCode&gt;&lt;MobileNumber&gt;'
    },
    // invalid number format
    'PROFILEREGO-CRITICAL-1334': {
        msg: 'Hey! We need to know what to call your device?'
    },
    // no device name supplied
    'PROFILEINFO-WARNING-2235': {
        // tslint:disable-next-line:max-line-length
        msg: 'Oh snap! The server may be down, or your network may not be properly connected? Please contact your Site Travel Administrator or try again later.'
    },
    'PROFILEINFO-WARNING-2236': {
        // tslint:disable-next-line:max-line-length
        msg: 'Could not get profiles with registered devices.'
    },
    'PROFILEINFO-WARNING-2237': {
        // tslint:disable-next-line:max-line-length
        msg: 'Not a valid file name.'
    },
    // default profile info fetch failed message
    // mostly used in route.js
    'PROFILEREGO-CRITICAL-1336': {
        msg: 'Ooops! This will not work without a mobile number!'
    },
    // no mobile number supplied
    'PROFILEREGO-CRITICAL-1337': {
        msg: 'Uh Oh! We seem to have a problem identifying your device? Please contact your Site Travel Administrator.'
    },
    // no device UUID
    'PROFILEREGO-CRITICAL-1338': {
        msg: 'Hey! We need to know what to call your device?'
    },
    // no deviceName supplied
    'PROFILEREGO-CRITICAL-1339': {
        msg: 'Who are you! I have no idea? Please contact your Site Travel Administrator.'
    }, // no resource id supplied
    'PROFILEREGO-CRITICAL-1340': {
        msg: 'Ooops! This will not work without an invited mobile number!'
    },
    // no mobile number supplied
    'PROFILEREGO-CRITICAL-1341': {
        msg: 'Ooops! This will not work without naming the invited user!'
    }, // no mobile number supplied
    'PROFILEREGO-CRITICAL-1342': {
        msg: 'Uh Oh! We seem to have a problem identifying your linked account. Please contact your Site Travel Administrator.'
    },
    // Missing master account phone number
    'PROFILEREGO-WARNING-1240': {
        msg: 'You have attempted to register too many times today. Try again tomorrow or contact your Site Travel Administrator.'
    },
    'PROFILEREGO-WARNING-1241': {
        msg: 'You have attempted to add too many sub accounts. Remove an existing account and try again.'
    },
    'PROFILEREGO-WARNING-1242': {
        msg: 'Access to this itinerary has been revoked. Please contact the profile owner to invite you again when required.'
    },
    'PROFILEREGO-WARNING-1243': {
        // tslint:disable-next-line:max-line-length
        msg: 'Whoops! We can\'t seem to find {deviceName} or they may have too many friends sharing with them already. Please contact {deviceName} and verify that they would like to see your itinerary.'
    }, // Sub user sharing limit
    'PROFILEREGO-WARNING-1245': {
        msg: 'First Date is required'
    },
    'PROFILEREGO-WARNING-1246': {
        msg: 'Last Date is required'
    },
    'PROFILEREGO-WARNING-1247': {
        msg: 'Transport Code is required'
    },
    'PROFILEREGO-WARNING-1248': {
        msg: 'Traveller ResId is required'
    },
    'PROFILEREGO-WARNING-1249': {
        msg: 'Reason for travel is required'
    },
    'PROFILEREGO-WARNING-1250': {
        msg: 'Resource status is required'
    },
    'PROFILEREGO-WARNING-1251': {
        msg: 'Site Prefix is required'
    },
    'PROFILEREGO-WARNING-1252': {
        msg: 'Workflow URL required'
    },
    'PROFILEREGO-WARNING-1253': {
        msg: 'Date is required'
    },
    'PROFILEREGO-WARNING-1254': {
        msg: 'Request failed, please contact administrator'
    },
    'PROFILEREGO-WARNING-1255': {
        msg: 'Failed to clear this item'
    },
    'PROFILEREGO-WARNING-1256': {
        msg: 'Profile Not Found'
    },
    'PROFILEREGO-WARNING-1257': {
        msg: 'Bad Request'
    },
    'PROFILEREGO-WARNING-1258': {
        msg: 'An Error occurred while getting settings'
    },
    'PROFILEREGO-WARNING-1260': {
        msg: 'Unable to process because the Transport Sequencing Rules would be broken'
    },
    'PROFILEREGO-WARNING-1261': {
        msg: 'Ooops, something is wrong? Please try again.'
    },
    'PROFILEREGO-WARNING-1262': {
        msg: 'Uh Oh! Manage Booking Sync failed? Please try again.'
    },
    'PROFILEREGO-WARNING-1263': {
        msg: 'Unable to Clear Fail request, document not found.'
    },
    'PROFILEREGO-WARNING-1264': {
        msg: 'Unable to cancel the request, Please try again.'
    },
    'PROFILEREGO-WARNING-1267': {
        msg: 'Reason for Cancellation required.'
    },
    'PROFILEREGO-INFORMATION-1130': {
        msg: 'Your request has been queued. The Workflow request number will be displayed shortly. Please refresh the Manage Booking page to view it.'
    },
    'PROFILEREGO-INFORMATION-1131': {
        msg: 'Item has been cleared.'
    },
    'EMAILITINERARY-CRITICAL-3301': {
        msg: 'From Date is required'
    },
    'EMAILITINERARY-CRITICAL-3302': {
        msg: 'To Date is required'
    },
    'EMAILITINERARY-CRITICAL-3303': {
        msg: 'Email is required'
    },
    'EMAILITINERARY-CRITICAL-3304': {
        msg: 'It appears that you have multiple itinerary providers (work sites) therefore you must select one'
    },
    'EMAILITINERARY-WARNING-3201': {
        msg: 'Unable to send request for email itinerary at the moment. Please try again later'
    },
    'EMAILITINERARY-INFORMATION-3101': {
        msg: 'Email itinerary sent'
    },
    'EMAILITINERARY-CRITICAL-3305': {
        msg: 'The date entered is not valid'
    },
    'EMAILITINERARY-CRITICAL-3306': {
        msg: 'Maximum number of email itinerary requests has been reached, please try again tomorrow'
    },
    'EMAILITINERARY-CRITICAL-3307': {
        msg: 'The to date should be after the from date'
    },
    'EMAILITINERARY-CRITICAL-3308': {
        msg: 'Maximum date range is {dataRange}'
    },
    'MAINTENANCE-INFORMATION-4100': {
        msg: 'No maintenace data'
    },
    'MAINTENANCE-INFORMATION-4101': {
        msg: 'Maintenance window time has been saved successfully'
    },
    'MAINTENANCE-CRITICAL-4300': {
        msg: 'An Error occurred while getting maintenance setting'
    }, 
    'MAINTENANCE-WARNING-4200': {
        msg: 'Invalid Request'
    },
    'MAINTENANCE-WARNING-4201': {
        msg: 'An Error occurred while updating maintenance setting'
    },
    'CLEAN-WARNING-5200': {
        msg: 'payload expected to be array'
    },
    'CLEAN-CRITICAL-5300': {
        msg: 'Uh Oh! Sync failed? Please try again.'
    },
};

export default messages;
